.buttons {
    margin: var(--space-xl) auto;
    text-align: center;
}